// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_js-0";